import React, { useState, useEffect } from 'react';
import { AthenaCore } from 'athena-core';
import { useAuth } from '../../contexts/AuthProvider/AuthProvider';
import Button from '../Button';
import AuthErrorBoundary from './AuthErrorBoundary';
import AuthForm from './AuthForm';
import Section from '../Modular/Section';
import Unit from '../Modular/Unit';
import './AuthFlow.css';
import Assembly from '../Modular/Assembly';
import { modalRef, ModalRefType } from 'athena-core/ref/modalRef';

const AuthFlow: React.FC = () => {
  const [mode, setMode] = useState<string | null>(null);
  const [showForm, setShowForm] = useState<boolean>(false);
  const { user } = useAuth();

  const toggleAuthState = () => {
    if (mode === 'login') {
      setMode('signup');
      setShowForm((prev) => true);
      console.log(showForm);
    } else {
      setMode('login');
      setShowForm((prev) => true);
    }
  };

  const toggleShowForm = () => {
    if (showForm) {
      setShowForm((prev) => false);
      setMode((prev) => null);
    } else {
      setShowForm((prev) => true);
      setMode((prev) => null);
    }
  };

  return (
    <>
      {mode === null && showForm === false && (
        <Unit
          as="div"
          layout="flex"
          flexDirection="row"
          gap="sm"
          justifyContent="flex-left"
          paddingTop="md"
        >
          <Button
            onClick={() => {
              setMode((prevState) => 'signup');
              setShowForm((prev) => true);
            }}
            variant="signup"
          >
            Sign Up
          </Button>
          <Button
            onClick={() => {
              setMode((prevState) => 'login');
              setShowForm((prev) => true);
            }}
            variant="secondary"
          >
            Login
          </Button>
        </Unit>
      )}

      {mode === 'login' && showForm === true && (
        <Section as="section" paddingTop="md" paddingBottom="md">
          <AuthForm
            mode={mode}
            toggleAuthState={toggleAuthState}
            toggleShowForm={toggleShowForm}
          />
        </Section>
      )}
      {mode === 'signup' && showForm === true && (
        <Section as="section" justifyItems="left">
          <AuthErrorBoundary>
            <AuthForm
              mode={mode}
              toggleAuthState={toggleAuthState}
              toggleShowForm={toggleShowForm}
            />
          </AuthErrorBoundary>
        </Section>
      )}
    </>
  );
};

export default AuthFlow;
